import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/CaseStudyLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/CaseStudyDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/CaseStudyHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/ImpactMetrics.tsx");
